import React from "react";
import informationIcon from "../../assets/img/Information.svg";

const CheckboxTyped = ({
  answer,
  handleChange,
  question,
  options,
  name,
  error,
  info,
}) => {
  return (
    <div className="cus_form basic_question_box">
      <div className="custom_filed custom_basic">
        <div className="form-group collection-question">
          <label htmlFor={name} className="basic" style={{ textAlign: "left" }}>
            {question}
            {info && (
              <img
                src={informationIcon}
                alt="Information"
                data-toggle="tooltip"
                data-placement="bottom"
                title={typeof info === "string" ? info : ""}
                style={{ cursor: "pointer", marginLeft: "5px" }}
              />
            )}
          </label>
          <ul>
            {options.map((option, index) => (
              <li key={index}>
                <input
                  id={`${name}-${index}`}
                  name={name}
                  type="checkbox"
                  value={option}
                  checked={answer?.includes(option) || false}
                  onChange={handleChange}
                />
                <label htmlFor={`${name}-${index}`}>{option}</label>
              </li>
            ))}
          </ul>
          {/* Display error message below the field */}
          {error && (
            <p className="text-danger" style={{ marginTop: "5px" }}>
              {error}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckboxTyped;
